<template>
  <div class="pay-panel">
    <ConfirmModal ref="confirmModal"></ConfirmModal>

    <div class="content">
      <div class="merchant-row">
        <div class="merchant-avatar" style="display: flex;align-items: center;justify-content: center;">
          <img :src="avatar ? avatar : icon_member_default" alt="" />
        </div>
        <div class="merchant-name">{{ merchantName }}</div>
      </div>

      <div class="amount-card">
        <div class="amount-label">付款金额</div>
        <div class="amount-line">
          <span class="amount-symbol">￥</span>
          <div class="input-c">
            <div class="input-c-div-1">{{ formatMoney(amount) }}</div>
            <div class="input-c-div" :style="'background:' + typeColor[payType] + ';border-color:' + typeColor[payType] + ';'"></div>
          </div>
        </div>
        <div class="remark-input" @click="myDialogStateFn(remark)">
          <span v-if="remark">{{ remark }}</span>
          <span v-else>添加备注</span>
        </div>
      </div>

      <div class="brand-logo">
        <img
          class="brand-logo-img"
          src="https://agent.fskeeper.com/img/乘鱼掌柜（黑色字体）.png"
          alt="乘鱼掌柜"
        />
      </div>
    </div>
    <MyDialog
        v-show="myDialogState"
        @myDialogStateFn="myDialogStateFn"
        :remark="remark"
        :typeColor="typeColor[payType]"
    >
    </MyDialog>

    <div class="keyboard-plus" v-if="isAllowModifyAmount">
      <Keyboard
          @delTheAmount="delTheAmount"
          @conceal="conceal"
          @enterTheAmount="enterTheAmount"
          @clearTheAmount="clearTheAmount"
          @payment="payment"
          @paymentAndInvoice="paymentAndInvoice"
          :money="money"
          :concealSate="concealSate"
          :typeColor="typeColor[payType]"
          :touchTypeColor="touchTypeColor[payType]"
          :invoiceEnabled="invoiceEnabled"
      ></Keyboard>
    </div>
    <div class="bnt-pay" v-if="!isAllowModifyAmount">
      <div class="bnt-pay-group">
        <div
            class="bnt-pay-text"
            :style="'background:' + typeColor[payType] + ';'"
            @click="pay"
        >
          付款
        </div>
        <div
            v-if="invoiceEnabled"
            class="bnt-pay-text-outline"
            :style="'color:' + typeColor[payType] + ';border-color:' + typeColor[payType] + ';'"
            @click="payAndInvoice"
        >
          付款+开票
        </div>
      </div>
    </div>

    <div v-if="paying" class="pay-loading-mask">
      <div class="pay-loading-box">
        <div class="pay-loading-spinner" :style="'border-top-color:' + typeColor[payType] + ';'"></div>
        <div class="pay-loading-text">处理中...</div>
      </div>
    </div>

    <!-- ====== 测试工具：直接传 tradeNo 调起支付 ====== -->
    <!-- <div class="debug-panel" style="margin:16px 16px 0;padding:12px;border:1px dashed #f5a623;border-radius:8px;font-size:13px;">
      <div style="font-weight:bold;margin-bottom:8px;color:#f5a623;">🔧 测试工具 - 直接调起支付宝支付</div>
      <div style="margin-bottom:8px;">
        <input
          v-model="debugTradeNo"
          placeholder="输入支付宝 tradeNo"
          style="width:100%;box-sizing:border-box;padding:6px 10px;border:1px solid #f5a623;border-radius:4px;font-size:13px;"
        />
      </div>
      <div style="display:flex;gap:8px;">
        <button @click="debugDoAlipay"
                style="padding:6px 14px;background:#f5a623;color:#fff;border:none;border-radius:4px;cursor:pointer;">
          调起支付
        </button>
        <button @click="debugTradeNo='2026052022001427161430119350'"
                style="padding:6px 14px;background:#eee;color:#333;border:none;border-radius:4px;cursor:pointer;">
          填入示例
        </button>
      </div>
      <div v-if="debugPayResult" style="margin-top:10px;background:#f5f5f5;border-radius:4px;padding:8px;word-break:break-all;white-space:pre-wrap;">{{ debugPayResult }}</div>
    </div> -->
    <!-- ====== end 测试工具 ====== -->

    <!-- ====== 测试工具：获取支付宝 openId / buyerId ====== -->
    <!-- <div class="debug-panel" style="margin:16px;padding:12px;border:1px dashed #1678ff;border-radius:8px;font-size:13px;">
      <div style="font-weight:bold;margin-bottom:8px;color:#1678ff;">🔧 测试工具 - 获取 OpenID</div>
      <div style="display:flex;gap:8px;flex-wrap:wrap;">
        <button @click="getAlipayAuthCode('auth_base')"
                style="padding:6px 14px;background:#1678ff;color:#fff;border:none;border-radius:4px;cursor:pointer;">
          静默授权 (auth_base)
        </button>
        <button @click="getAlipayAuthCode('auth_user')"
                style="padding:6px 14px;background:#ff9800;color:#fff;border:none;border-radius:4px;cursor:pointer;">
          主动授权 (auth_user)
        </button>
        <button @click="debugInfo = ''" v-if="debugInfo"
                style="padding:6px 14px;background:#ccc;color:#333;border:none;border-radius:4px;cursor:pointer;">
          清除
        </button>
      </div>
      <div v-if="debugInfo" style="margin-top:10px;background:#f5f5f5;border-radius:4px;padding:8px;word-break:break-all;white-space:pre-wrap;">{{ debugInfo }}</div>
      <div style="margin-top:8px;color:#999;font-size:11px;">
        ① 点击按钮拿到 authCode<br>
        ② 把 authCode 交给后端调支付宝 alipay.system.oauth.token 换取 openId/buyerId
      </div>
    </div> -->
    <!-- ====== end 测试工具 ====== -->
  </div>
</template>

<script>
import { getPayPackage, getPayOrderInfo, getMyTransactions, cancelPay } from '@/api/api'
import config from "@/config";
import wayCodeUtils from '@/utils/wayCode'
import MyDialog from "@/views/dialog/dialog";
import Keyboard from "@/views/keyboard/keyboard";
export default {
  components: { MyDialog, Keyboard },
  data: function (){
    return {
      merchantName: '乘鱼掌柜',
      avatar: require("../../assets/images/zfb.jpeg"),
      amount: "",
      resData : {},
      payImg: require("../../assets/images/zfb.jpeg"),
      payOrderInfo: {},
      isAllowModifyAmount: true,
      myDialogState: false,
      remark: "",
      money: -1,
      concealSate: true,
      paying: false,
      payType: "alipay",
      invoiceEnabled: false,
      fromInvoice: false,
      invoiceList: [],
      transactionList: [],
      showInvoiceList: false,
      showTransactionList: false,
      // 商户推广引流：抖音/快手/小红书链接拼接文案，下单（点付款手势）时复制到剪贴板
      promoCopyText: '',
      debugInfo: "",
      debugTradeNo: "2026052022001427161430119350",
      debugPayResult: "",
      typeColor: {
        alipay: "#1678ff",
        wxpay: "#07c160",
        ysfpay: "#ff534d"
      },
      touchTypeColor: {
        alipay: "rgba(20, 98, 206, 1)",
        wxpay: "rgba(7, 130, 65, 1)",
        ysfpay: "rgb(248 70 65, 1)"
      },
    }
  },
  mounted() {
    this.fromInvoice = this.$route.query.fromInvoice === '1';
    this.loadInvoiceRecords();
    this.fetchMyTransactions();
    this.setPayOrderInfo();
  },
  methods: {
    loadInvoiceRecords() {
      this.invoiceList = JSON.parse(sessionStorage.getItem('invoiceRecords') || '[]');
      if (this.invoiceList.length > 0) this.showInvoiceList = true;
    },
    fetchMyTransactions() {
      const that = this;
      getMyTransactions(50).then(list => {
        that.transactionList = Array.isArray(list) ? list : [];
        if (that.transactionList.length > 0) that.showTransactionList = true;
      }).catch(() => {
        that.transactionList = [];
      });
    },
    formatTxnYuan(amountFen) {
      if (amountFen == null || amountFen === '') return '0.00';
      const n = Number(amountFen);
      if (isNaN(n)) return String(amountFen);
      return (n / 100).toFixed(2);
    },
    formatTxnTime(item) {
      const raw = item.successTime || item.createdAt || item.createTime;
      if (!raw) return '';
      const d = new Date(raw);
      if (isNaN(d.getTime())) return String(raw);
      return d.getFullYear() + '-' +
          String(d.getMonth() + 1).padStart(2, '0') + '-' +
          String(d.getDate()).padStart(2, '0') + ' ' +
          String(d.getHours()).padStart(2, '0') + ':' +
          String(d.getMinutes()).padStart(2, '0');
    },
    payment() {
      if (this.money == -1)
        return;
      this.pay();
    },
    paymentAndInvoice() {
      if (this.money == -1)
        return;
      this.goInvoicePage();
    },
    conceal() {
      this.concealSate = !this.concealSate
    },
    enterTheAmount(item) {
      if (this.amount >= 9999999
          || (item === "." && this.amount.includes("."))
          || (this.amount.includes(".") && this.amount.split(".").pop().length >= 2)
      ) {
        return;
      }
      if (this.amount === "0") {
        this.amount = item.toString();
      } else {
        this.amount = `${this.amount}${item}`;
      }
      if (this.amount === ".") {
        this.amount = "0.";
      }
      if (!Number.isNaN(this.amount)) {
        this.payOrderInfo.amount = this.amount * 100;
      } else {
        this.payOrderInfo.amount = 0;
      }
      this.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1;
    },
    delTheAmount() {
      this.amount = this.amount.substring(0, this.amount.length - 1)
      if (!Number.isNaN(this.amount)) {
        this.payOrderInfo.amount = this.amount * 100;
      } else {
        this.payOrderInfo.amount = 0;
      }
      this.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1;
    },
    clearTheAmount(){
      this.amount = "";
      this.payOrderInfo.amount = 0;
      this.money = -1;
    },
    formatMoney(money) {
      let part = money.toString().split('.');
      let l = part[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      let r = part.length > 1 ? `.${part.pop()}` : '';
      return `${l}${r}`
    },
    myDialogStateFn: function (remark) {
      this.remark = remark;
      this.myDialogState = !this.myDialogState;
    },
    setPayOrderInfo(){
      const that = this
      getPayOrderInfo().then(res => {
        that.payOrderInfo = res
        that.merchantName = res.mchName
        that.promoCopyText = that.buildPromoCopyText(res.promotion)
        that.amount = Number(res.amount) > 0 ? (res.amount / 100) + "" : ""
        that.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1
        that.isAllowModifyAmount = res.fixedFlag !== 1
        that.invoiceEnabled = !!res.invoiceEnabled
        if (res.payOrderId && !that.fromInvoice) {
          const fixedRoute = wayCodeUtils.getFixedRouteName()
          if (fixedRoute) {
            that.$router.replace({ name: fixedRoute })
          }
          return
        }
      }).catch(res => {
        that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
      });
    },
    payAndInvoice: function () {
      this.goInvoicePage();
    },
    goInvoicePage() {
      this.$router.push({
        name: 'CashierInvoice',
        query: { amount: this.amount, payType: this.payType, remark: this.remark }
      });
    },
    buildPromoCopyText(promo) {
      if (!promo) return '';
      const parts = [];
      if (promo.douyinVideoUrl) parts.push('抖音：' + promo.douyinVideoUrl);
      if (promo.kuaishouVideoUrl) parts.push('快手：' + promo.kuaishouVideoUrl);
      if (promo.xiaohongshuVideoUrl) parts.push('小红书：' + promo.xiaohongshuVideoUrl);
      return parts.join('\n');
    },
    copyToClipboard(text) {
      if (!text) return Promise.resolve();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(() => this.fallbackCopy(text));
      }
      return Promise.resolve(this.fallbackCopy(text));
    },
    fallbackCopy(text) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* ignore */ }
      document.body.removeChild(ta);
    },
    pay: function () {
      if (this.paying) return;
      let that = this;
      this.paying = true;
      // 在用户点击「付款」的手势上下文中复制推广链接（此时剪贴板写入最可靠），
      // 支付完成后用户即可直接到抖音/快手/小红书粘贴打开。
      if (this.promoCopyText) {
        this.copyToClipboard(this.promoCopyText);
      }
      getPayPackage(this.amount, this.remark).then(res => {
        that.paying = false;
        if (res.code && res.code != '0') {
          return that.$confirm({ title: '请求失败', content: res.msg, typeColor: that.typeColor[that.payType] });
        }
        if (res.orderState != 1) {
          return that.$confirm({ title: '订单异常', content: res.errMsg, typeColor: that.typeColor[that.payType] });
        }
        that.resData = res;
        if (!window.AlipayJSBridge) {
          document.addEventListener('AlipayJSBridgeReady', function () {
            that.doAlipay(res.alipayTradeNo);
          }, false);
        } else {
          that.doAlipay(res.alipayTradeNo);
        }
      }).catch(res => {
        that.paying = false;
        that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
      });
    },
    /** 测试用：直接用 tradeNo 调起支付宝支付（跳过下单流程） */
    debugDoAlipay() {
      const tradeNo = (this.debugTradeNo || '').trim();
      if (!tradeNo) {
        this.debugPayResult = '❌ 请先输入 tradeNo';
        return;
      }
      this.debugPayResult = `⏳ 正在调起支付，tradeNo=${tradeNo}`;
      const that = this;

      const doCall = () => {
        // eslint-disable-next-line no-undef
        AlipayJSBridge.call('tradePay', { tradeNO: tradeNo }, function (data) {
          console.log('[debugDoAlipay] result', data);
          const code = data && data.resultCode;
          const desc = {
            '9000': '✅ 支付成功',
            '8000': '⚠️ 处理中',
            '6004': '⚠️ 支付结果未知',
            '6001': '🚫 用户取消',
            '6002': '❌ 网络连接错误',
          }[code] || `❓ 其他结果码`;
          that.debugPayResult = `${desc}\nresultCode: ${code}\n\n完整结果:\n${JSON.stringify(data, null, 2)}`;
        });
      };

      if (!window.AlipayJSBridge) {
        that.debugPayResult = '等待 AlipayJSBridge 就绪（请在支付宝App内打开）...';
        document.addEventListener('AlipayJSBridgeReady', doCall, false);
      } else {
        doCall();
      }
    },
    /**
     * 测试用：获取支付宝 authCode，控制台 + 页面同时展示
     * scope:
     *   auth_base  —— 静默授权，用户无感知，只能拿 openId/userId
     *   auth_user  —— 主动授权，需用户确认，能拿手机号/昵称等
     */
    getAlipayAuthCode(scope = 'auth_base') {
      const that = this;
      that.debugInfo = `正在请求 ${scope} 授权...`;

      const doGet = () => {
        // eslint-disable-next-line no-undef
        AlipayJSBridge.call('getAuthCode', {
          appId: that.payOrderInfo.appId || '',   // 若后端 payOrderInfo 有 appId 则自动填入
          scopes: [scope],
        }, function (result) {
          console.log('[Alipay AuthCode]', result);
          if (result && result.authCode) {
            that.debugInfo =
              `✅ 拿到 authCode:\n${result.authCode}\n\n` +
              `scope: ${scope}\n` +
              `⬇ 把上面的 authCode 给后端换取 openId/buyerId\n` +
              `POST /alipay.system.oauth.token\n  grant_type=authorization_code\n  code=${result.authCode}`;
          } else {
            that.debugInfo = `❌ 获取失败:\n${JSON.stringify(result)}`;
          }
        });
      };

      if (!window.AlipayJSBridge) {
        document.addEventListener('AlipayJSBridgeReady', doGet, false);
        that.debugInfo = '等待 AlipayJSBridge 就绪...（请在支付宝 App 内打开本页面）';
      } else {
        doGet();
      }
    },
    handlePayCancel() {
      const that = this;
      cancelPay(this.resData.payOrderId).catch(() => {
        // 取消回调不阻塞用户离开，后端可通过订单超时兜底处理。
      }).finally(() => {
        that.$confirm({
          title: '提示',
          content: '支付已取消',
          typeColor: that.typeColor[that.payType],
          onOk: () => window.AlipayJSBridge.call('closeWebview')
        });
      });
    },
    doAlipay(alipayTradeNo) {
      const that = this
      // eslint-disable-next-line no-undef
      AlipayJSBridge.call("tradePay", {
        tradeNO: alipayTradeNo
      }, function (data) {
        if ("9000" == data.resultCode) {
          if (that.payOrderInfo.returnUrl) {
            location.href = that.payOrderInfo.returnUrl;
          } else {
            that.$confirm({
              title: '提示',
              content: '支付已完成',
              typeColor: that.typeColor[that.payType],
              onOk: () => window.AlipayJSBridge.call('closeWebview')
            });
          }
        } else if ("8000" == data.resultCode || "6004" == data.resultCode) {
          that.$confirm({
            title: '支付状态',
            content: JSON.stringify(data),
            typeColor: that.typeColor[that.payType],
            onOk: () => window.AlipayJSBridge.call('closeWebview')
          });
        } else if ("6001" == data.resultCode) {
          that.handlePayCancel()
        } else {
          that.handlePayCancel()
        }
      });
    },
  }
}
</script>
<style lang="css" scoped>
@import './pay.css';

.pay-loading-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.pay-loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 28px 36px;
  gap: 14px;
}
.pay-loading-spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #e0e0e0;
  border-top-color: #1678ff;
  border-radius: 50%;
  animation: pay-spin 0.8s linear infinite;
}
.pay-loading-text {
  font-size: 14px;
  color: #555;
}
@keyframes pay-spin {
  to { transform: rotate(360deg); }
}
</style>
